import styled, { keyframes } from 'styled-components';

const slideUp = keyframes`
  from {
    transform: translateY(100%);
  }

  to {
    transform: translateY(0%);
  }
`;

export const CookieBannerContainer = styled.div`
  position: fixed;
  left: 50%;
  bottom: var(--space-m);

  width: min(92vw, 760px);

  transform: translateX(-50%);

  z-index: 1000;

  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-m);

  padding: var(--space-s) var(--space-m);

  background: rgba(0, 0, 0, 0.92);

  color: var(--white);

  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 999px;

  box-shadow: 0 18px 42px rgba(0, 0, 0, 0.22);

  animation: ${slideUp} 0.45s ease-out;

  p {
    margin: 0;

    color: rgba(255, 255, 255, 0.82);

    font-size: 0.88rem;
    line-height: 1.5;
    font-weight: 500;

    text-align: left;
  }

  div {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: var(--space-xs);

    flex-shrink: 0;
  }

  button {
    min-width: 96px;
    max-width: 160px;
    min-height: 34px;

    padding: var(--space-xxs) var(--space-s);

    font-size: 0.85rem;
  }

  button:focus {
    outline: 2px solid var(--yellow5, #ffe066);
    outline-offset: 2px;
  }

  @media screen and (max-width: 700px) {
    width: calc(100% - var(--space-m));
    bottom: var(--space-s);

    align-items: stretch;
    flex-direction: column;

    border-radius: 18px;

    padding: var(--space-m);

    p {
      text-align: center;
    }

    div {
      width: 100%;
      justify-content: center;
    }

    button {
      flex: 1;
      width: 100%;
      max-width: none;
    }
  }

  @media screen and (max-width: 430px) {
    div {
      flex-direction: column;
    }
  }
`;
